import React, { Component } from 'react';

const Controller = HeaderComponent => class extends Component {
  constructor(props) {
    super(props);
    this.state = {
      menus: [],
      path: '',
      isMenuOpen: false,
    }
  }
  
  onClickUp = () => {
    window.scrollTo(0, 0);
  }

  onClickDown = () => {
    window.scrollTo(0,document.body.scrollHeight);
  }

  onClickToOpen = () => {
    this.setState({
      isMenuOpen: !this.state.isMenuOpen,
    }, () => {
      const { isMenuOpen } = this.state;
      if (isMenuOpen) {
        document.body.style.overflow = 'hidden';
      } else {
        document.body.style.overflow = '';
      }
    });
  }

  render() {
    return (
      <HeaderComponent
        {...this.state}
        {...this.props}
        onClickUp={this.onClickUp}
        onClickDown={this.onClickDown}
        onClickToOpen={this.onClickToOpen} />
    );
  }
}

export default Controller;



// WEBPACK FOOTER //
// ./client/components/Header/Controller.js